"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _gsap = require("gsap");

var _reactTransitionGroup = require("react-transition-group");

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _easing = _interopRequireDefault(require("../easing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  alwaysShowInDom: _propTypes.bool,
  children: _propTypes.node,
  easing: _propTypes.func,
  enterDuration: _propTypes.number,
  exitDuration: _propTypes.number,
  show: _propTypes.bool,
  showAnimation: _propTypes.bool
};

var Fade = function Fade(_ref) {
  var children = _ref.children,
      _ref$easing = _ref.easing,
      easing = _ref$easing === void 0 ? ["Power4", "easeOut"] : _ref$easing,
      _ref$enterDuration = _ref.enterDuration,
      enterDuration = _ref$enterDuration === void 0 ? 0.25 : _ref$enterDuration,
      _ref$exitDuration = _ref.exitDuration,
      exitDuration = _ref$exitDuration === void 0 ? 0.2 : _ref$exitDuration,
      _ref$alwaysShowInDom = _ref.alwaysShowInDom,
      alwaysShowInDom = _ref$alwaysShowInDom === void 0 ? true : _ref$alwaysShowInDom,
      show = _ref.show,
      _ref$showAnimation = _ref.showAnimation,
      showAnimation = _ref$showAnimation === void 0 ? true : _ref$showAnimation;
  return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
    appear: true,
    enter: showAnimation,
    exit: showAnimation,
    "in": showAnimation && show,
    mountOnEnter: !alwaysShowInDom,
    onEnter: function onEnter(child) {
      _gsap.TweenLite.set(child, {
        opacity: 0
      });

      _gsap.TweenLite.to(child, enterDuration, {
        ease: (0, _ramda.path)(easing, _easing["default"]),
        opacity: 1
      });
    },
    onExit: function onExit(child) {
      _gsap.TweenLite.to(child, exitDuration, {
        ease: (0, _ramda.path)(easing, _easing["default"]),
        opacity: 0
      });
    },
    timeout: {
      enter: enterDuration * 1000,
      exit: exitDuration * 1000
    },
    unmountOnExit: !alwaysShowInDom
  }, children);
};

Fade.propTypes = propTypes;
var _default = Fade;
exports["default"] = _default;